const AUTH = "[AUTH]";

// command
export const LOGOUT = `${AUTH} LOGOUT`;

// document
export const SET_AUTH_CRED = `${AUTH} SET`;
export const PATCH_AUTH_CRED = `${AUTH} PATCH`;

// event

export const setAuth = (auth) => ({
   type: SET_AUTH_CRED,
    payload: {
        data: auth
    }
});

export const patch = (auth) => ({
    type: SET_AUTH_CRED,
    payload: {
        data: auth
    }
});

export const logout = () => ({
    type: LOGOUT
});
